import React, { useContext, useEffect } from "react";
import {
    ButtonProps,
    ButtonRenderProps,
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    SearchBox,
    Stack
} from "sprint-common-web";

import { ResolutionListingItem } from "../context/ResolutionListingItem";
import { ResolutionsListingContext } from "../context/ResolutionsListingContext";
import { AddResolutionButton } from "./buttons/AddResolutionButton";
import { useResolutionsListingFilters } from "./useResolutionsListingFilters";

export const ResolutionsListing: React.FC = () => {
    const { filters, setName, clearFilters, setPage, setPageSize, setSort } = useResolutionsListingFilters();
    const { items, allItems, totalItems, isLoading, load } = useContext(ResolutionsListingContext);

    useEffect(() => {
        load(filters);
    }, [filters, allItems, allItems.length]);

    const columns = createListTableColumns<ResolutionListingItem>([
        {
            type: "basic",
            key: "name",
            name: "Resolution",
            minWidth: 200,
            maxWidth: 250
        },
        {
            type: "basic",
            key: "width",
            name: "Width",
            minWidth: 200,
            maxWidth: 450,
            isSortable: true
        },
        {
            type: "basic",
            key: "height",
            name: "Height",
            minWidth: 200,
            maxWidth: 250,
            isSortable: true
        }
    ]);

    const addResolutionButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddResolutionButton
    };

    return (
        <ContentSection header={"Resolutions"} buttons={[addResolutionButtonProps]}>
            <Grid>
                <GridRow>
                    <GridColumn sm={4}>
                        <SearchBox placeholder="Resolution" onChange={setName} value={filters.name} />
                    </GridColumn>

                    <GridColumn sm={8}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={items}
                            isLoading={isLoading}
                            pagination={{
                                ...filters,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
